import React, { Component } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { startEditEntry } from '../../actions/entryActions';
import PropTypes from 'prop-types';
import EntryForm from './EntryForm';

export class EditEntryPage extends Component {

  onFormActionSubmit = (entry) => {
    this.props.startEditEntry(this.props.entry.id, entry);
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Edit Entry
        </Typography>
        <EntryForm
          entry={this.props.entry}
          editMode
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const paramId = Number(props.match.params.id);
  return { entry: state.entries.find(entry => entry.id === paramId) };
};

const mapDispatchToProps = (dispatch) => ({
    startEditEntry: (id, entry) => dispatch(startEditEntry(id, entry)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEntryPage);



// WEBPACK FOOTER //
// ./src/components/entries/EditEntryPage.js